import type { ReactNode } from 'react';

export interface DeliveryCardProps {
  children: ReactNode;
  className?: string;
}

// Two-layer glass background — tinted gradient on top, dark base
// underneath. Kept literal (instead of behind a helper) so the
// design-constructor invariant scanner can see every `--co-…` token
// it depends on.
const DELIVERY_FORM_CARD_BG =
  'linear-gradient(' +
  'var(--co-DeliveryFormCard-bgDirection, to bottom), ' +
  'color-mix(in srgb, var(--co-DeliveryFormCard-bgFrom, rgba(255,255,255,0.20)) ' +
  'calc(var(--co-DeliveryFormCard-bgOpacity, 1) * 100%), transparent) 0%, ' +
  'color-mix(in srgb, var(--co-DeliveryFormCard-bgTo, rgba(153,153,153,0.20)) ' +
  'calc(var(--co-DeliveryFormCard-bgOpacity, 1) * 100%), transparent) 100%), ' +
  'linear-gradient(90deg, ' +
  'var(--co-DeliveryFormCard-darkTint, rgba(0,0,0,0.18)) 0%, ' +
  'var(--co-DeliveryFormCard-darkTint, rgba(0,0,0,0.18)) 100%)';

/**
 * Outer glass card shared by both Delivery pages (New / Show). All
 * surface tokens live behind the `--co-DeliveryFormCard-*` namespace
 * so Design Constructor can theme this surface independently of the
 * My Packs list cards. `data-co-component` exposes the inspect
 * handle.
 */
export function DeliveryCard({ children, className = '' }: DeliveryCardProps) {
  return (
    <div
      data-co-component="DeliveryFormCard"
      className={`rounded-[28px] p-5 @[600px]:p-6 ${className}`}
      style={{
        backgroundImage: DELIVERY_FORM_CARD_BG,
        backdropFilter: 'blur(var(--co-DeliveryFormCard-glassBlur, 27px))',
        WebkitBackdropFilter: 'blur(var(--co-DeliveryFormCard-glassBlur, 27px))',
        borderStyle: 'solid',
        borderWidth: 'var(--co-DeliveryFormCard-borderWidth, 1px)',
        borderColor: 'var(--co-DeliveryFormCard-borderColor, rgba(171,174,179,0.20))',
        color: 'var(--co-DeliveryFormCard-titleColor, #FFFFFF)',
      }}
    >
      {children}
    </div>
  );
}
